<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card shadow-lg">
          <div class="card-header pb-0">
            <div class="d-flex align-items-center justify-content-between">
              <p class="mb-0 font-weight-bold">Editar Usuario: {{ user.full_name }}</p>

              <argon-button
                color="warning"
                size="sm"
                @click="requestPasswordReset"
              >
                Reestablecer Contraseña
              </argon-button>
            </div>
          </div>

          <div class="card-body">
            <div v-if="isLoading" class="text-center py-5">
              <div class="spinner-border text-success" role="status"></div>
              <p class="mt-2 text-sm text-secondary">Cargando datos del usuario...</p>
            </div>

            <form v-else @submit.prevent="submitUser">
              <div class="row">
                <div class="col-md-6">
                  <label class="form-control-label">Nombre Completo</label>
                  <argon-input v-model="user.full_name" type="text" placeholder="Juan Pérez" />
                  <small v-if="submitted && v$.user.full_name.$error" class="text-danger">Requerido.</small>
                </div>

                <div class="col-md-6">
                  <label class="form-control-label">Documento de Identidad</label>
                  <argon-input v-model="user.document" type="text" placeholder="001-000000-0000U" />
                  <small v-if="submitted && v$.user.document.$error" class="text-danger">Documento requerido.</small>
                </div>

                <div class="col-md-6 mt-3">
                  <label class="form-control-label">Username</label>
                  <argon-input v-model="user.username" type="text" readonly disabled />
                </div>

                <div class="col-md-6 mt-3">
                  <label class="form-control-label">Email</label>
                  <argon-input v-model="user.email" type="email" placeholder="email@dominio.com" />
                  <small v-if="submitted && v$.user.email.$error" class="text-danger">Email válido requerido.</small>
                </div>

                <div class="col-md-6 mt-3">
                  <label class="form-control-label">Rol</label>
                  <select class="form-control" v-model.number="user.role_id">
                    <option :value="null">Seleccione un rol</option>
                    <option v-for="role in roles" :key="role.id" :value="role.id">
                      {{ role.name }}
                    </option>
                  </select>
                  <small v-if="submitted && v$.user.role_id.$error" class="text-danger">Rol requerido.</small>
                </div>

                <div class="col-md-6 mt-3">
                  <label class="form-control-label">Sucursal Asignada</label>
                  <select class="form-control" v-model.number="user.fk_branch_id" :disabled="userRole === 2">
                    <option :value="null">Seleccione una sucursal</option>
                    <option v-for="branch in branches" :key="branch.id" :value="branch.id">
                      {{ branch.name }}
                    </option>
                  </select>
                  <small v-if="submitted && v$.user.fk_branch_id.$error" class="text-danger">Sucursal requerida.</small>
                </div>

                <div class="col-md-6 mt-3">
                  <label class="form-control-label">Estado</label>
                  <div class="form-check form-switch mt-2">
                    <input class="form-check-input" type="checkbox" id="isActiveSwitch" v-model="user.is_active" :true-value="1" :false-value="0">
                    <label class="form-check-label" for="isActiveSwitch">{{ user.is_active === 1 ? 'Activo' : 'Inactivo' }}</label>
                  </div>
                </div>
              </div>

              <argon-button
                type="submit"
                class="mt-5"
                color="success"
                fullWidth
                size="lg"
              >
                Guardar Cambios
              </argon-button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, email, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';

export default {
  name: "EditUser",
  components: { ArgonInput, ArgonButton },
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      isLoading: true,
      submitted: false,
      roles: [],
      branches: [], // Lista de sucursales
      user: {
        id: this.$route.params.id,
        username: '',
        email: '',
        document: '', // Nuevo campo
        role_id: null,
        fk_branch_id: null, // Nuevo campo
        full_name: '',
        is_active: 1,
        company: parseInt(localStorage.getItem('companyId')),
      },
      branchId:parseInt(localStorage.getItem('branchId')),
      userRole:parseInt(localStorage.getItem('userLevel'))
    };
  },
  validations() {
    return {
      user: {
        full_name: { required: helpers.withMessage('Requerido', required) },
        document: { required: helpers.withMessage('Requerido', required) },
        email: {
          required: helpers.withMessage('Requerido', required),
          email: helpers.withMessage('Email inválido', email)
        },
        role_id: { required: helpers.withMessage('Rol requerido', required) },
        fk_branch_id: { required: helpers.withMessage('Sucursal requerida', required) },
      }
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    async fetchData() {
      this.isLoading = true;
      const token = localStorage.getItem("accessToken");
      const config = { headers: { 'Authorization': `Bearer ${token}` } };
      const apiURL = this.$store.state.apiURL;

      try {
        // 1. Cargar Roles, Sucursales y Datos del Usuario en paralelo
        const [rolesRes, branchesRes, userRes] = await Promise.all([
          axios.get(`${apiURL}roles`, config),
          axios.get(`${apiURL}branches?company=${this.user.company}`, config),
          axios.get(`${apiURL}users/${this.user.id}`, config)
        ]);

        this.roles = rolesRes.data;

        this.branches = branchesRes.data;
        if(this.userRole==2){
            this.user.fk_branch_id=this.branchId
            this.branches= this.branches.filter(x=> x.id==this.branchId);
            this.roles=this.roles.filter(x=> x.id>1);
        }
        // 2. Mapear datos del usuario
        this.user = {
          ...this.user,
          ...userRes.data,
          // Aseguramos que los valores sean enteros para los selectores y switches
          role_id: parseInt(userRes.data.role_id),
          fk_branch_id: userRes.data.fk_branch_id ? parseInt(userRes.data.fk_branch_id) : null,
          is_active: parseInt(userRes.data.is_active)
        };

      } catch (error) {
        console.error("Error al cargar datos:", error);
        this.handleSessionError(error);
      } finally {
        this.isLoading = false;
      }
    },

    async submitUser() {
      this.submitted = true;
      this.v$.$touch();

      if (this.v$.$invalid) {
        Swal.fire({ title: 'Datos inválidos', text: 'Revisa los campos requeridos.', icon: 'warning' });
        return;
      }

      const token = localStorage.getItem("accessToken");
      const apiURL = this.$store.state.apiURL;
      const config = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } };

      // Limpiamos el payload de campos que no deben enviarse en el PUT
      let payload = { ...this.user };
      delete payload.password;
      delete payload.username; // Usualmente no se permite cambiar el username

      try {
        await axios.put(`${apiURL}users/${this.user.id}`, payload, config);

        Swal.fire({
          title: 'Actualizado',
          text: `El usuario ${this.user.full_name} fue actualizado correctamente.`,
          icon: 'success',
          confirmButtonColor: '#0b9257'
        }).then(() => {
          this.$router.push('/settings/users');
        });

      } catch (err) {
        const errorText = err.response?.data?.message || 'No se pudo guardar el usuario.';
        Swal.fire({ title: 'Error', text: errorText, icon: 'error' });
      }
    },

    async requestPasswordReset() {
      // (Mantenido igual que tu código original)
      if (!this.user.id || !this.user.email) return;
      Swal.fire({
        title: 'Confirmar Restablecimiento',
        text: `¿Enviar enlace a ${this.user.email}?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sí, enviar'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await axios.post(`${this.$store.state.apiURL}password/request`, {email:this.user.email}, {
              headers: { 'Authorization': `Bearer ${localStorage.getItem("accessToken")}` }
            });
            Swal.fire('Enviado', 'Enlace enviado con éxito.', 'success');
          } catch (err) {
            Swal.fire('Error', 'No se pudo enviar el enlace.', 'error');
          }
        }
      });
    },

    handleSessionError(error) {
      if (error.response?.status === 401) {
        this.$router.push('/signin');
      }
    }
  },
};
</script>